import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function MockDataGeneratorPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Mock Data Generator - JsonToonCraft",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free mock data generator. Generate realistic test user data with names, emails, ages, and timestamps.",
    "featureList": [
      "Generate test user data",
      "Realistic names and emails",
      "Customizable record count",
      "JSON format output",
      "Copy to clipboard",
      "Instant generation"
    ]
  };

  return (
    <>
      <SEO
        title="Mock Data Generator - Generate Test User Data | JsonToonCraft"
        description="Free mock data generator. Generate realistic test user data with names, emails, ages, and timestamps. Perfect for testing and development."
        keywords="mock data generator, test data generator, fake data generator, sample data, dummy data, JSON test data"
        canonicalUrl="https://jsontooncraft.com/dev-tools/mock-data-generator"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="mock" />
    </>
  );
}
